module.exports = __webpack_public_path__ + "static/media/illustrationPack.95da1ed1.jpg";